var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2101_1161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9998 16.7627L15.9998 26.6667L5.99975 16.7627C5.34016 16.1208 4.82061 15.3493 4.47381 14.4968C4.12702 13.6443 3.9605 12.7293 3.98473 11.8092C4.00897 10.8892 4.22343 9.98417 4.61463 9.15111C5.00582 8.31804 5.56526 7.575 6.25773 6.96876C6.9502 6.36253 7.76069 5.90624 8.63817 5.62863C9.51564 5.35102 10.4411 5.2581 11.3562 5.35573C12.2714 5.45335 13.1564 5.7394 13.9556 6.19587C14.7548 6.65233 15.4507 7.26933 15.9998 8.00799C16.5511 7.27469 17.2479 6.66309 18.0466 6.21146C18.8452 5.75984 19.7284 5.47792 20.641 5.38335C21.5536 5.28878 22.4759 5.38359 23.3501 5.66185C24.2244 5.94011 25.0318 6.39582 25.7218 7.00048C26.4119 7.60513 26.9697 8.3457 27.3603 9.17585C27.751 10.006 27.9661 10.9078 27.9922 11.8249C28.0183 12.742 27.8548 13.6546 27.5119 14.5057C27.1691 15.3567 26.6543 16.1278 25.9998 16.7707",
    stroke: "#DBDBDB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2101_1161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.6b05ba72a92d9e0fb68aad25f337bcaf.svg";
export { ForwardRef as ReactComponent };